import constantes from '../helpers/constanteHelper'
import { retornarTexto } from '../helpers/textoHelper'

import Image from 'react-bootstrap/Image';

import aves from '../images/aves.png'
import bovinosLeite from '../images/bovinos-leite.png'
import bovinosCorte from '../images/bovinos-corte.png'
import bovinosCentrais from '../images/centrais.png'
import pescados from '../images/pescados.png'
import suinos from '../images/suinos.png'

function EspeciesBEA({ item, resolucaoMobile, idioma }) {
    const estiloIcone = { height: '35px' }

    return (
        <div className='animate__animated animate__fadeIn d-flex flex-column align-items-center justify-content-center' style={{ gap: '20px' }}>
            <span style={{ color: constantes.CORES.BRANCO_PADRAO }} >{retornarTexto(idioma, 'especies')}: </span>
            <div className='animate__animated animate__fadeIn d-flex align-items-center justify-content-center' style={{ gap: '10px' }}>
                {item['Avicultura']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={aves} alt='logo' fluid /> : <></>}
                {item['Bovinos - Centrais']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={bovinosCentrais} alt='logo' fluid /> : <></>}
                {item['Bovinos de Corte']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={bovinosCorte} alt='logo' fluid /> : <></>}
                {item['Bovinos de Leite']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={bovinosLeite} alt='logo' fluid /> : <></>}
                {item['Pescados']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={pescados} alt='logo' fluid /> : <></>}
                {item['Suínos']?.toUpperCase() === 'X' ? <Image style={estiloIcone} src={suinos} alt='logo' fluid /> : <></>}
            </div>
        </div>
    );
}
export default EspeciesBEA;
